import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { BASE_URL } from '../../api/inquiries';
import './Login.css';

const Login = () => {
    const [step, setStep] = useState(1); // 1: ID/PW, 2: PIN
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [pin, setPin] = useState('');
    const [error, setError] = useState('');
    const [verifying, setVerifying] = useState(false);

    const navigate = useNavigate();
    const { login } = useAuth();

    // Step 1: Verify Password
    const handleVerifyPassword = async (e) => {
        e.preventDefault();
        setError('');
        setVerifying(true);

        try {
            const response = await fetch(`${BASE_URL}/api/auth/verify-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
            });

            if (!response.ok) {
                throw new Error('Invalid credentials');
            }

            // If success, move to PIN step
            setStep(2);
        } catch (err) {
            console.error(err);
            setError('아이디 또는 비밀번호가 올바르지 않습니다.');
        } finally {
            setVerifying(false);
        }
    };

    // Step 2: Final Login with PIN
    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setVerifying(true);

        try {
            const response = await fetch(`${BASE_URL}/api/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password, pin }),
            });

            if (!response.ok) {
                const data = await response.json().catch(() => ({}));
                if (data.message === 'Invalid PIN code') {
                    throw new Error('PIN 번호가 올바르지 않습니다.');
                }
                throw new Error('로그인에 실패했습니다.');
            }

            const data = await response.json();
            login(data.access_token, username);
            navigate('/admin/dashboard');
        } catch (err) {
            setError(err.message);
        } finally {
            setVerifying(false); // Should redirect anyway if success
        }
    };

    return (
        <div className="login-container" style={{ maxWidth: '400px', margin: '100px auto', padding: '2rem', border: '1px solid #ddd', borderRadius: '8px' }}>
            <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>관리자 로그인</h2>
            {error && <div style={{ color: '#e11d48', marginBottom: '1rem', textAlign: 'center', fontSize: '0.9rem' }}>{error}</div>}

            {step === 1 ? (
                <form onSubmit={handleVerifyPassword}>
                    <div style={{ marginBottom: '1rem' }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem' }}>아이디</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            autoComplete="username"
                            style={{ width: '100%', padding: '0.5rem' }}
                            required
                        />
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem' }}>비밀번호</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"
                            style={{ width: '100%', padding: '0.5rem' }}
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={verifying}
                        style={{ width: '100%', padding: '0.75rem', backgroundColor: '#333', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                    >
                        {verifying ? '확인 중...' : '다음 (PIN 인증)'}
                    </button>
                </form>
            ) : (
                <form onSubmit={handleLogin}>
                    <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
                        <p style={{ marginBottom: '10px', fontWeight: 'bold' }}>2차 보안 인증</p>
                        <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '20px' }}>오늘의 업무 PIN 번호를 입력하세요.</p>

                        <input
                            type="password"
                            value={pin}
                            onChange={(e) => setPin(e.target.value)}
                            // placeholder="PIN 6자리"
                            style={{
                                width: '200px', padding: '0.8rem', fontSize: '1.5rem',
                                textAlign: 'center', letterSpacing: '0.5rem'
                            }}
                            maxLength={6}
                            autoFocus
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={verifying}
                        style={{ width: '100%', padding: '0.75rem', backgroundColor: '#2563eb', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', marginBottom: '10px' }}
                    >
                        {verifying ? '로그인 중...' : '로그인 완료'}
                    </button>
                    <button
                        type="button"
                        onClick={() => { setStep(1); setError(''); setPin(''); }}
                        style={{ width: '100%', padding: '0.75rem', backgroundColor: 'transparent', color: '#666', border: 'none', cursor: 'pointer' }}
                    >
                        뒤로 가기
                    </button>
                </form>
            )}
        </div>
    );
};

export default Login;
